StepperVue(:default-current-step='fanCurrentStep' :steps='steps' :show-progress-bar='showProgressBar' @completed='onComplete' data-test='kyc-stepper')
